import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { gender_choices, university_choices } from "../../constants/choices";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import API_ROUTES from "../../constants/apis";
import logpic2 from "../../assets/students.jpg";

const SignUp = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    password1: "",
    password2: "",
    university: "",
    gender: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Send form data to the API

    try {
      const response = await axios.post(API_ROUTES.SIGN_UP, formData);
      console.log(response);
      navigate("/verify");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="h-screen bg-slate-300 text-blue-950">
      <div className="h-5/6 flex justify-center items-center">
        <div className="h-65vh flex shadow-2xl rounded-lg bg-slate-200">
          <div
            className="bg-no-repeat bg-center bg-cover rounded-l-lg hidden md:block"
            style={{
              backgroundImage: `url(${logpic2})`,
            }}
          >
            <div>
              <h3 className=" text-center text-2xl font-bold   p-2 ">
                Karibu <br /> <span className="text-4xl">Student Keja</span>
              </h3>
            </div>
          </div>

          <div className="p-5 rounded-r-lg h-full flex flex-col items-center justify-center">
            <h2 className="text-center text-3xl">StudentKeja</h2>
            <h3 className="text-center text-xl">REGISTER</h3>
            <form
              onSubmit={handleSubmit}
              className="max-w-sm mx-auto bg-white/5 px-5 py-10"
            >
              <div className="mb-4 flex justify-between gap-2">
                <label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    placeholder="First Name"
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  />
                </label>
                <label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    placeholder="Last Name"
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  />
                </label>
              </div>

              <div className="mb-4">
                <label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email Address"
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  />
                </label>
              </div>
              <div className="mb-4">
                <label>
                  <PhoneInput
                    defaultCountry="KE"
                    placeholder="Phone Number eg: 791665710"
                    value={formData.phone}
                    required
                    onChange={(value) =>
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        phone: value,
                      }))
                    }
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  />
                </label>
              </div>
              <div className="mb-4">
                <label>
                  <select
                    name="university"
                    value={formData.university || "defaultValue"}
                    onChange={handleInputChange}
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  >
                    <option value="defaultValue" disabled>
                      Select university
                    </option>
                    {Object.entries(university_choices).map(
                      ([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      )
                    )}
                  </select>
                </label>
              </div>

              <div className="mb-4">
                <label>
                  <select
                    name="gender"
                    value={formData.gender || "defaultValue"}
                    onChange={handleInputChange}
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  >
                    <option value="defaultValue" disabled>
                      Select gender
                    </option>
                    {Object.entries(gender_choices).map(([value, label]) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="mb-4 flex gap-2">
                <label>
                  <input
                    type="password"
                    name="password1"
                    value={formData.password1}
                    onChange={handleChange}
                    minLength={6}
                    required
                    placeholder="Password"
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  />
                </label>
                <label>
                  <input
                    type="password"
                    name="password2"
                    value={formData.password2}
                    onChange={handleChange}
                    minLength={6}
                    required
                    placeholder="Confirm Password"
                    className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none bg-slate-200"
                  />
                </label>
              </div>
              <button
                type="submit"
                className="w-full bg-red-600 hover:bg-red-700 text-white p-2 rounded-md mt-5"
              >
                Sign Up
              </button>
            </form>

            <div>
              <p>
                {" "}
                Have an account?
                <Link to="/login" className="text-red-500 p-2">
                  Login here
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-blue-950 text-center">
        © 2023 StudentKeja.com. All Rights Reserved | Developed by Rades
      </p>
    </div>
  );
};

export default SignUp;
